import { consentApiReady, denyAllConsent, marketingDenied } from '@theme/na-privacy-consent';

const POLL_MS = 50;
const GIVE_UP_MS = 10000;

if (navigator.globalPrivacyControl === true) {
    const started = Date.now();
    const poll = setInterval(() => {
        if (marketingDenied()) {
            clearInterval(poll);
        } else if (consentApiReady()) {
            clearInterval(poll);
            denyAllConsent('gpc');
        } else if (Date.now() - started > GIVE_UP_MS) {
            clearInterval(poll);
            console.warn('[gpc] Consent APIs never loaded. The browser opt out signal was not applied.');
        }
    }, POLL_MS);
}
